/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Anchor_Clear_ConfirmInputs */

const en_us2_body_assessment_anchor_clear_confirm = /** @type {(inputs: Body_Assessment_Anchor_Clear_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop using it`)
};

const pt_br2_body_assessment_anchor_clear_confirm = /** @type {(inputs: Body_Assessment_Anchor_Clear_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parar de usar`)
};

const es_419_body_assessment_anchor_clear_confirm = /** @type {(inputs: Body_Assessment_Anchor_Clear_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dejar de usarla`)
};

const pt_pt2_body_assessment_anchor_clear_confirm = /** @type {(inputs: Body_Assessment_Anchor_Clear_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixar de usar`)
};

const fr_fr2_body_assessment_anchor_clear_confirm = /** @type {(inputs: Body_Assessment_Anchor_Clear_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne plus l'utiliser`)
};

const de_de2_body_assessment_anchor_clear_confirm = /** @type {(inputs: Body_Assessment_Anchor_Clear_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht mehr nutzen`)
};

const it_it2_body_assessment_anchor_clear_confirm = /** @type {(inputs: Body_Assessment_Anchor_Clear_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smetti di usarlo`)
};

/**
* | output |
* | --- |
* | "Stop using it" |
*
* @param {Body_Assessment_Anchor_Clear_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_anchor_clear_confirm = /** @type {((inputs?: Body_Assessment_Anchor_Clear_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Anchor_Clear_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_anchor_clear_confirm(inputs)
	if (locale === "es-419") return es_419_body_assessment_anchor_clear_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_anchor_clear_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_anchor_clear_confirm(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_anchor_clear_confirm(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_anchor_clear_confirm(inputs)
	return en_us2_body_assessment_anchor_clear_confirm(inputs)
});
export { body_assessment_anchor_clear_confirm as "body-assessment.anchor_clear_confirm" }